import { SMALL } from 'lib/DeviceScreen';
import { useMedia } from 'react-use';
import { DealerListing } from 'lib/models/DealerListing';
import MobileSearchResultsCarousel from 'components/DealerListingsCarousel/MobileSearchResultsCarousel';
import DesktopSearchResultsCarousel from 'components/DealerListingsCarousel/DesktopSearchResultsCarousel';

interface Props {
  listings: DealerListing[];
}

export default function DealerListingsCarousel({ listings }: Props): JSX.Element {
  const shouldRenderMobileCarouselState = useMedia(`(max-width: ${SMALL.cssMaxWidth})`);

  return shouldRenderMobileCarouselState ? (
    <MobileSearchResultsCarousel vehicles={listings} />
  ) : (
    <DesktopSearchResultsCarousel vehicles={listings} />
  );
}
